export interface RawSubscriptionPlan {
  id: string;
  name: string;
  price: number;
  duration_days: number;
  features: string | Record<string, unknown>;
}

export interface TransformedSubscriptionPlan {
  id: string;
  name: string;
  price: number;
  duration_days: number;
  features: {
    max_accounts: number;
    reports: string;
    analytics: boolean;
    advisor: boolean;
  };
}

/**
 * Parse Plan Features.
 */
export function parsePlanFeatures(
  features: string | Record<string, unknown>
): Record<string, unknown> {
  if (typeof features === "string") {
    try {
      return JSON.parse(features) as Record<string, unknown>;
    } catch {
      return {};
    }
  }

  if (features && typeof features === "object") {
    return features;
  }

  return {};
}

/**
 * Transform Subscription Plan.
 */
export function transformSubscriptionPlan(plan: RawSubscriptionPlan): TransformedSubscriptionPlan {
  const featuresObj = parsePlanFeatures(plan.features);

  return {
    id: plan.id,
    name: plan.name,
    price: plan.price,
    duration_days: plan.duration_days,
    features: {
      max_accounts: Number(featuresObj.max_accounts ?? 0),
      reports: typeof featuresObj.reports === "string" ? featuresObj.reports : "none",
      analytics: Boolean(featuresObj.analytics ?? false),
      advisor: Boolean(featuresObj.advisor ?? false),
    },
  };
}

export function transformSubscriptionPlans(
  plans: RawSubscriptionPlan[] | null | undefined
): TransformedSubscriptionPlan[] {
  return (plans ?? []).map(transformSubscriptionPlan);
}
